import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';

axios.defaults.withCredentials = true;

// Ensure the role is always synced from JWT token at startup
const storedToken = localStorage.getItem("token");
if (storedToken && !localStorage.getItem("role")) {
  try {
    const base64Url = storedToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    if (payload.role) {
      localStorage.setItem('role', payload.role);
    }
  } catch (e) { /* ignore decode errors */ }
}

const selectedCompanyId = localStorage.getItem("selected_company_id");
if (selectedCompanyId && selectedCompanyId !== "all") {
  axios.defaults.headers.common['x-selected-company-id'] = selectedCompanyId;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter >
    <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
